import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [{
        path: 'list',
        name: 'list',
        component: resolve => {
            require(['@/views/order/list.vue'], resolve);
        },
        meta: {
            title: '订单列表'
        }
    },
    {
        path: 'detail',
        name: 'detail',
        component: resolve => {
            require(['@/views/order/newDetail.vue'], resolve);
        },
        meta: {
            title: '订单详情',
            needDoubleConfirm: true
        }
    },
    {
        path: 'prepare',
        name: 'prepare',
        component: resolve => {
            require(['@/views/order/prepare.vue'], resolve);
        },
        meta: {
            title: '确认订单'
        }
    },
	{
	    path: 'confirmation',
	    name: 'confirmation',
	    component: resolve => {
	        require(['@/views/order/confirmation.vue'], resolve);
	    },
	    meta: {
            title: '订单确认',
            normal: true
	    }
	},

]

let route = [{
    path: '/orders',
    component: CommomProxy,
    children: child_routes
}]

export default route



// WEBPACK FOOTER //
// ./src/router/order.js